<template>
  <div id="footer">
    <div class="wrap">
      <div class="box_l">
        <ul>
          <li><h3>{{$t('footer.aboutUsTitle')}}</h3></li>
          <li><router-link to="/content/about">{{$t('footer.aboutUs')}}</router-link></li>
          <li><router-link to="/content/contact">{{$t('footer.contactUs')}}</router-link></li>
          <li><a href="javascript:;">{{$t('footer.business')}}</a></li>
        </ul>
        <ul>
          <li><h3>{{$t('footer.legalTitle')}}</h3></li>
          <li><router-link to="/content/term">{{$t('footer.terms')}}</router-link></li>
          <li><router-link to="/content/privacy">{{$t('footer.privacy')}}</router-link></li>
          <li><router-link to="/content/refund">{{$t('footer.refund')}}</router-link></li>
        </ul>
        <ul>
          <li><h3>{{$t('footer.regionTitle')}}</h3></li>
          <li><a href="javascript:;">{{$t('footer.'+regionName,regionName)}}</a></li>
          <li><h3 style="margin-top: 5px;margin-bottom:5px">{{$t('footer.language')}}</h3></li>
          <el-dropdown @command="changeLang">
            <div>
              <li v-if="$i18n.locale === 'zh-TW'"><a href="javascript:;">{{$t('footer.langZhCN')}}</a></li>
              <li v-if="$i18n.locale === 'en'"><a href="javascript:;">{{$t('footer.langEn')}}</a></li>
              <li v-if="$i18n.locale === 'ko'"><a href="javascript:;">{{ koreanLanguageLabel }}</a></li>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh-TW">{{$t('footer.langZhCN')}}</el-dropdown-item>
              <el-dropdown-item command="en">{{$t('footer.langEn')}}</el-dropdown-item>
              <el-dropdown-item command="ko">{{ koreanLanguageLabel }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </ul>
        <ul>
          <li><h3>{{$t('footer.serviceTitle')}}</h3></li>
          <li><router-link to="/help">{{$t('footer.helpSupport')}}</router-link></li>
          <li><a href="javascript:;" @click="openOnlineService">{{$t('footer.onlineService')}}</a></li>
        </ul>
      </div>
      <div class="box_r">
        <ul>
          <li v-for="item in floorBanner" :key="item.id">
            <a href="javascript:;"><img :src="item.imgUrl" /></a>
          </li>
          <!-- <li v-for="item in floorBanner" :key="item.id">
            <a href="javascript:;"><img :src="item.imgUrl" /></a>
          </li> -->
          <!-- <li>
            <a href="javascript:;"><img src="../assets/pay_2.png" /></a>
          </li>
          <li>
            <a href="javascript:;"><img src="../assets/pay_3.png" /></a>
          </li>
          <li>
            <a href="javascript:;"><img src="../assets/pay_4.png" /></a>
          </li>
          <li>
            <a href="javascript:;"><img src="../assets/pay_5.png" /></a>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="copyright">
      <p>
        All copyrights, trademarks and service marks belong to their respective owners. Copyright © 2025 KKkor LTD. All Rights Reserved<br/>
        Additional <router-link to="/content/term">Terms</router-link> and <router-link to="/content/privacy">Privacy Policy</router-link>
      <!-- {{list[0].description}} -->
      </p>
      <p></p>
    </div>
  </div>
</template>

<script>
import { getArticleLlist } from "@/api/article.js";
import { openSupportChat } from "@/utils/support-chat";
import { setManualLocalePreference } from "@/utils/locale-preference";
export default {
  name: "FooterCom",
  components: {},
  data() {
    return {
      list: [],
      floorBanner:[],
      koreanLanguageLabel: '\uD55C\uAD6D\uC5B4',
      regionName:""
    };
  },
  created() {
    this.getDicts();
    this.regionName=this.$store.getters.regionName;
  },
  methods: {
    changeLang(lang){
      const resolvedLocale = setManualLocalePreference(lang);
      this.$i18n.locale = resolvedLocale || lang;
      location.reload();
    },
    async openOnlineService() {
      await openSupportChat(this.$route, this.$store.state.user.userInfo);
    },
    getDicts() {
      // getArticleLlist({
      //   code: "record",
      // }).then((res) => {
      //   this.list = res.data;
      // });
      getArticleLlist({
        code: "floor_banner",
      }).then((res) => {
        this.floorBanner = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 768px) {
  #footer {
    height: 318px;
    background: #2f2f2f;
    .wrap {
      width: 1125px;
      overflow: hidden;
      padding-top: 70px;
      padding-bottom: 30px;

      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
      .box_l {
        float: left;
        overflow: hidden;
        ul {
          float: left;
          width: 180px;
          li {
            h3 {
              font-size: 18px;
              font-weight: bold;
              color: #797979;
              margin-bottom: 10px;
            }
            a {
              color: #e9e9e9;
              font-size: 14px;
              line-height: 2;
            }
          }
        }
      }
      .box_r {
        float: right;
        ul {
          overflow: hidden;
          width: 280px;
          display:flex;
          flex-wrap: wrap;
          li {
            float: left;
            margin-right: 56px;
            margin-bottom: 30px;
            &:nth-child(3n) {
              margin-right: 0;
            }
            a {
              img {
                width: 56px;
              }
            }
          }
        }
      }
    }
    .copyright {
      max-width: 1020px;
      margin: 0 auto;
      text-align: center;
      padding-top: 12px;
      p {
        color: #a0a0a0;
        line-height: 2;
        a{
          color: #a0a0a0;
          &:hover{
          text-decoration: underline;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  #footer {
    height: 159px;
    width: 100%;
    background: #2f2f2f;
    .wrap {
      width: 100%;
      background: #2f2f2f;
      overflow: hidden;
      padding-top: 20px;
      padding-bottom: 15px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);

      .box_l {
        // float: left;
        overflow: hidden;
        display: flex;
        justify-content: center;
        ul {
          width: 25%;
          display: flex;
          flex-direction: column;
          align-items: center;

          li {
            h3 {
              font-size: 13px;
              font-weight: bold;
              color: #797979;
              margin-bottom: 5px;
            }
            a {
              color: #e9e9e9;
              font-size: 11px;
              //   line-height: 1;
              margin-top: 20px;
            }
          }
        }
      }
      .box_r {
        width: 100%;
        // float: right;
        ul {
          width: 100%;
          display: flex;
          overflow: hidden;
          margin-top: 10px;
          // border: 1px solid red;
          // justify-content: space-around;
          flex-wrap: wrap;
          li {
            margin-left:28px;
            margin-bottom: 15px;
            // &:nth-child(3n) {
            //   margin-right: 0;
            // }
            a {
              img {
                width: 38px;
              }
            }
          }
        }
      }
    }
    .copyright {
      background: #2f2f2f;
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      text-align: center;
      //   padding-top: 12px;
      p {
        color: #a0a0a0;
        line-height: 2;
        font-size: 10px;
      }
    }
  }
}
</style>
